import { Button } from 'react-bootstrap'

import { forwardRef } from 'react'
import { CustomSpinner } from '../CustomSpinner'

export const CustomButton = forwardRef(
  (
    {
      isLoading,
      isLoadingText,
      isDisabled,
      isDisabledText,
      isSuccess,
      secondary,
      isDelete,
      noMargin,
      isEdit,
      title,
      titleColor,
      color = '#0d6efd',
      children,
      ...rest
    },
    ref,
  ) => {
    return (
      <Button
        ref={ref}
        type="button"
        size="sm"
        disabled={isLoading || isDisabled}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: noMargin && 0,
          gap: 10,
          cursor: isDisabled || isLoading ? 'not-allowed' : 'pointer',
          backgroundColor: isDelete
            ? '#e70f0f'
            : isEdit
              ? '#ec630a'
              : isSuccess
                ? '#198754'
                : secondary
                  ? '#808080'
                  : color,
          color: titleColor || '#fff',
          ...rest.styles,
        }}
        {...rest}
      >
        {isLoading ? (
          <>
            <CustomSpinner
              size={18}
              color="#fff"
            />

            {isLoadingText && isLoadingText}
          </>
        ) : isDisabled && isDisabledText ? (
          <>{isDisabledText}</>
        ) : (
          <>
            {children}

            {title}
          </>
        )}
      </Button>
    )
  },
)
